
import Icon from 'JS/components/Icon.vue';
import { createRadioBase } from './BRadioBase';
import { defineComponent, PropType } from 'vue';

const { withRadioBaseProps, useRadioBase } = createRadioBase();

/**
 * Layout options for BRadioCard.
 *
 * - "default"
 *   The default layout choice. Shows a circular indicator that looks like a traditional radio button.
 *   Actions are rendered below the main slot content.
 *
 * - "no-radio"
 *   Differs from default in that:
 *   - The radio indicator is removed
 *   - Actions are rendered on the right-hand side of the card
 */
type BRadioCardLayout =
	| "default"
	| "no-radio"

export default defineComponent({
	name: 'BRadioCard',
	components: {
		Icon
	},
	props: {
		...withRadioBaseProps(),
		error: { type: String, required: false, default: '' },
		ariaDescribedby: String,
		/**
		 * See {@link BRadioCardLayout}
		 * Defaults to "default"
		 */
		layout: { type: String as PropType<BRadioCardLayout>, default: 'default' as BRadioCardLayout }
	},
	setup(props, { emit }) {
		return {
			...useRadioBase(props, emit),
		};
	}
});
